import { useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import LayoutContext from '../contexts/Layout'

interface CSSProps {
  imageSize: number,
  containerSize: number,
}

const withSharedStylesBase = makeStyles(theme => ({
  rootPage: {
    minHeight: '100%',
    paddingBottom: theme.spacing(5),
    '& a': {
      color: theme.palette.secondary.main,
    },
    '& a:visited': {
      color: theme.palette.secondary.main,
    },
    '& h3': {
      fontWeight: 400,
    },
    '& h4': {
      fontWeight: 400,
    },
    '& h5': {
      fontWeight: 400,
    },
    '& h6': {
      fontWeight: 400,
    },
  },
  textBottomMargin: {
    marginBottom: theme.spacing(4),
  },
  marginContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  marginTopContainer: {
    marginTop: theme.spacing(4),
  },
  marginBottomContainer: {
    marginBottom: theme.spacing(4),
  },
  paddingContainer: {
    paddingTop: theme.spacing(4),
  },
  paddingHalfContainer: {
    paddingTop: theme.spacing(2),
  },
  paddingDoubleContainer: {
    paddingTop: theme.spacing(6),
  },
  doublePaddingContainer: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  noPaddingBottom: {
    paddingBottom: 0,
  },
  centerContainer: {
    textAlign: 'center',
  },
  contentFlexContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(2),
  },
  contentFlexVertContainer: {
    flexDirection: 'column',
  },
  greySection: {
    //backgroundColor: '#e5e5e5',
    color: '#333',
  },
  quoteContainer: {
    //backgroundColor: '#f5f5f5',
    textAlign: 'left',
    color: '#666',
    padding: theme.spacing(1),
  },
  containerWrapper: {
    display: 'flex !important',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: ({containerSize}: CSSProps) => ({
    width: `${containerSize}px`,
    maxWidth: `${containerSize}px`,
    paddingLeft: '0px',
    paddingRight: '0px',
  }),
  videoMargin: {
    backgroundColor: '#000',
    padding: '3px',
  },
  centerText: {
    textAlign: 'center',
  },
  noUnderline: {
    textDecoration: 'none',
    color: 'black',
  },
  titleText: {
    fontWeight: 400,
    color: 'black',
    textDecoration: 'none',
  },
  circleImage: {
    borderRadius: '50%',
  },
  homepageContainer: {
    marginTop: '40px',
  }
}))

const withSharedStyles = () => {
  const {
    imageSize,
    containerSize,
  } = useContext(LayoutContext)

  const classes = withSharedStylesBase({
    imageSize,
    containerSize,
  })

  return classes
}

export default withSharedStyles